var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C3.34315 4 2 5.34315 2 7V19.9868L5.64242 17H19C20.6569 17 22 15.6569 22 14V7C22 5.34315 20.6569 4 19 4H5ZM6.35758 19L3.26816 21.5333C2.41403 22.2337 1.15385 22.1091 0.453464 21.2549C0.160246 20.8974 0 20.4492 0 19.9868V7C0 4.23858 2.23858 2 5 2H19C21.7614 2 24 4.23858 24 7V14C24 16.7614 21.7614 19 19 19H6.35758Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#A0ACB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSms);
export default __webpack_public_path__ + "static/media/sendSms.d5d1d57a44f1f7f10518f4d64856d70d.svg";
export { ForwardRef as ReactComponent };